export default {"src":"/_next/static/media/logo-black-new.e1e7c1e6.svg","height":486,"width":1600,"blurWidth":0,"blurHeight":0};